import { render, staticRenderFns } from "./triggers-list.vue?vue&type=template&id=aaf7f06a&"
import script from "./triggers-list.vue?vue&type=script&lang=js&"
export * from "./triggers-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports